
  import { css } from 'lit';
  export const styles = css`:host{--message-color: var(--ig-dialog-message-color, var(--ig-gray-700));--border-radius: var(--ig-dialog-border-radius, clamp(0rem, calc(var(--ig-radius-factor, 0.0555555556) * 2.25rem), 2.25rem));--ig-theme: fluent;--ig-theme-variant: light}`;
  